<template>
  <div
    class="file-card"
    :class="{
      danger: color === 'danger',
    }"
  >
    <div class="file-icon__wrapper">
      <iconify-icon icon="fa-solid:image" v-if="file.type.includes('image')" />
      <iconify-icon icon="fa-solid:play" v-else-if="file.type.includes('video')" />
      <iconify-icon icon="fa-solid:file-alt" v-else />
    </div>

    <div class="flex flex-col w-full file-description__wrapper">
      <span class="filename">{{ file.name }}</span>
      <span class="description file-size">{{ formatBytes(file.size) }}</span>
    </div>

    <div class="end">
      <button @click="$emit('delete', file)" class="del"></button>
    </div>
  </div>
</template>

<script>
  import { formatBytes } from '@/utils/strings';

  export default {
    name: 'FileCard',
    emits: ['delete'],
    props: {
      file: { type: Object, required: true },
      deletable: Boolean,
      color: String,
    },
    data() {
      return {};
    },
    methods: {
      formatBytes,
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';

  .file-card {
    padding: 1.125rem 1rem;
    background-color: $white;
    border-radius: 0.5rem;
    border: 1px solid $input-border;

    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 1rem;

    .file-description__wrapper {
      overflow-wrap: break-word;
      word-wrap: break-word;
      overflow: hidden;

      .filename {
        width: 100%;
      }
    }

    .file-icon__wrapper {
      min-height: 2rem;
      min-width: 2rem;
      height: fit-content;
      border-radius: 50%;
      background-color: $input-border;
      display: grid;
      place-items: center;
    }

    &.danger {
      border-color: $communication-danger;
      border-style: dashed;

      .file-size {
        font-weight: 600;
        color: $communication-danger;
      }
    }
  }
</style>
